export const snapScrollPosition = (node: HTMLElement, onChange: (i: number) => void) => {
  const onScroll = () => {
    const scrollWidth = node.scrollWidth;
    const progress = node.scrollLeft + node.clientWidth;
    onChange(Math.round((progress / scrollWidth) * node.children.length - 1));
  };

  node.addEventListener('scroll', onScroll);

  return {
    destroy() {
      node.removeEventListener('scroll', onScroll);
    }
  };
};
